module.exports = __webpack_public_path__ + "static/media/b35cb94f-7a98-46d2-b449-f26c302024e5_1.329520f4d20940161a167e6e213e7e88.052b5ae9.jpeg";